import { render, staticRenderFns } from "./SolicitudesReversibles.vue?vue&type=template&id=baf5d0fe&scoped=true"
import script from "./SolicitudesReversibles.vue?vue&type=script&lang=js"
export * from "./SolicitudesReversibles.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesReversibles.vue?vue&type=style&index=0&id=baf5d0fe&prod&scoped=true&lang=css"
import style1 from "./SolicitudesReversibles.vue?vue&type=style&index=1&id=baf5d0fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf5d0fe",
  null
  
)

export default component.exports